declare var Quill: any;

const BaseImageFormat = Quill.import('formats/image');
const ImageFormatAttributesList = [
    'alt',
    'height',
    'width',
    'style'
];

export let PresetValues = {}

export class ImageFormat extends BaseImageFormat {
  static formats(domNode: any) {
    Object.keys(PresetValues).forEach(x => {
      domNode.setAttribute(x, PresetValues[x])
    })

    PresetValues = {};
    // adding default styles START
    const defaultMaxWidth = ' max-width: 100%;'
    if (!domNode.hasAttribute('style')) domNode.setAttribute('style', defaultMaxWidth);
    else {
      let styles = domNode.getAttribute('style');
      if (styles.indexOf('max-width') < 0) styles += defaultMaxWidth;
    }
    // adding default styles END

    return ImageFormatAttributesList.reduce(function(formats, attribute) {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }
  format(name, value) {
    if (ImageFormatAttributesList.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/controls/html-editor/html.editor-ext.ts